import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ChromePicker } from 'react-color';

import { toRGBnotation } from '~/modules/helpers/object';
import { toRGBobj } from '~/modules/helpers/string';

const ColorPicker = props => {
    const [displayColorPicker, setDisplayColorPicker] = useState(false);

    const convert = value => toRGBobj(value, props.title);

    const [color, setColor] = useState(convert(props.value));

    useEffect(() => {
        setColor(convert(props.value));
    }, [props.value]);

    return (
        <div
            className={
                // prettier-ignore
                `color-picker ${
                    props.disabled 
                        ? 'disabled'
                        : 'enabled'
                } is-${
                    displayColorPicker 
                        ? 'open'
                        : 'close'
                }`
            }
        >
            <div
                className="preview"
                style={
                    color
                        ? {
                              backgroundColor: toRGBnotation(color)
                          }
                        : null
                }
                onClick={
                    props.disabled
                        ? null
                        : () => {
                              setDisplayColorPicker(!displayColorPicker);
                          }
                }
            />
            {displayColorPicker && (
                <div className="popup">
                    <div
                        className="box"
                        onClick={() => {
                            setDisplayColorPicker(false);
                        }}
                    />
                    <ChromePicker
                        {...props}
                        color={color}
                        onChange={color => {
                            setColor(color.rgb);
                        }}
                        onChangeComplete={props.onChange}
                    />
                </div>
            )}
        </div>
    );
};

ColorPicker.propTypes = {
    /**
     * Value can be expressed as object or string
     * the object version should have 'r', 'g' and 'b' properties
     * the string version should be like 'rgb(\d+, \d+, \d+)' or 'rgba(\d+, \d+, \d+, \d+)'
     */
    value: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.shape({
            r: PropTypes.number,
            g: PropTypes.number,
            b: PropTypes.number
        }),
        PropTypes.string
    ]),
    title: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func
};

ColorPicker.defaultProps = {
    value: {},
    title: '',
    disabled: false
};

export default ColorPicker;
